import { Guest } from '@/app/system/guest/Guest';
import { GuestAware } from '@/app/system/guest/GuestAware';
import { GuestDynamic } from '@/app/system/guest/GuestDynamic';
import { Patron } from '@/app/system/guest/Patron';
import { SourceEmpty } from '@/app/system/guest/SourceEmpty';
import { RequestDocument } from '@/app/system/request/RequestDocument';
import { RequestPart } from '@/app/system/request/RequestPart';
import { axiosBitrix } from '@/shared/plugins/axiosBitrix';

/**
 * @deprecated legacy
 */
export class BusEndpoint implements RequestPart {
  request(guest: Guest<RequestDocument>): this {
    guest.receive({
      transportInstance: axiosBitrix,
      url: '/',
      method: 'get',
      params: {},
      body: {},
    });
    return this;
  }
}

export class BusClient<T> implements GuestAware<T> {
  private source = new SourceEmpty<T>();

  public constructor(
    private loading: Guest<boolean>,
    private baseRequest: GuestAware<RequestDocument>,
    private error: Guest<Error>,
  ) {
    this.baseRequest.receiving(new Patron(new GuestDynamic(request => {
      this.loading.receive(true);
      axiosBitrix.request(request)
        .then(response => {
          this.source.receive(response.data);
          this.loading.receive(false);
        })
        .catch(e => {
          this.error.receive(e);
          this.loading.receive(false);
        });
    })));
  }

  public receiving(guest: Guest<T>) {
    this.source.receiving(guest);
    return this;
  }
}
